import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { ApproveModalComponent } from './approve/approve-modal.component';
import { DialogResult, ModalDialogResult } from '../../models/modal-dialog-result';
import { RejectReasonComponent } from './reject/reject-reason.component';
import { ConfirmDeleteModalComponent } from './confirm-delete/confirm-delete-modal.component';
import { GenericConfirmModalComponent } from './generic/generic-confirm-modal.component';
import { ApproveCondition } from '../../models/approve-condition.model';
import { ApproveConditionallyModalComponent } from './reject copy/approve-conditionally-modal.component';

@Injectable({
    providedIn: 'root'
})
export class ConfirmModalService {

    constructor(private modalService: NgbModal) {
    }

    public showApproveConfirmDialog(): Observable<DialogResult> {
        const options: NgbModalOptions = {
            backdrop: 'static',
            centered: true
        };
        const modalRef = this.modalService.open(ApproveModalComponent, options);
        return modalRef.componentInstance.onClose;
    }
    
    public showApproveConditionallyConfirmDialog(): Observable<ModalDialogResult<ApproveCondition>> {
        const options: NgbModalOptions = {
            backdrop: 'static',
            centered: true
        };
        const modalRef = this.modalService.open(ApproveConditionallyModalComponent, options);
        return modalRef.componentInstance.onClose;
    }

    public showRejectConfirmDialog(): Observable<ModalDialogResult<string>> {
        const options: NgbModalOptions = {
            backdrop: 'static',
            centered: true
        };
        const modalRef = this.modalService.open(RejectReasonComponent, options);
        return modalRef.componentInstance.onClose;
    }

    public showConfirmDelete(): Observable<DialogResult> {
        const options: NgbModalOptions = {
            backdrop: 'static',
            centered: true
        };
        const modalRef = this.modalService.open(ConfirmDeleteModalComponent, options);
        return modalRef.componentInstance.onClose;
    }

    public showConfirmDialog(message: string, title: string | null = null) : Observable<DialogResult> {
        const options: NgbModalOptions = {
            backdrop: 'static',
            centered: true
        };

        const modalRef = this.modalService.open(GenericConfirmModalComponent, options);
        modalRef.componentInstance.message = message;
        if(title) {
            modalRef.componentInstance.title = title;
        }
        
        return modalRef.componentInstance.onClose;
    }
}

